import * as Sentry from "@sentry/browser";

const logging = {
  logException(err) {
    let sentryClient = Sentry.getCurrentHub().getClient();
    if (!sentryClient) {
      console.error(err);
    } else {
      Sentry.captureException(err);
    }
  }
};

export default logging;
